import { supabase } from "@/integrations/supabase/client";
import { alertDealerSignupBlock } from "@/lib/dealerSignupAlert.functions";

export type DealerSignupStep =
  | "wizard_opened"
  | "step_1_completed"
  | "step_2_completed"
  | "submit_clicked"
  | "validation_failed"
  | "file_too_large"
  | "checkout_url_received"
  | "checkout_redirect"
  | "checkout_error"
  | "error";

/** Steps that mean the user is stuck and we want an email alert. */
const BLOCKING_STEPS: DealerSignupStep[] = [
  "validation_failed",
  "file_too_large",
  "checkout_error",
  "error",
];

interface TrackArgs {
  step: DealerSignupStep;
  email?: string | null;
  errorField?: string | null;
  errorMessage?: string | null;
  metadata?: Record<string, unknown>;
}

/**
 * Fire-and-forget logging of each step of the /dealeri signup wizard.
 * Never throws. Sends an admin email alert on blocking steps.
 */
export function trackDealerSignupStep(args: TrackArgs): void {
  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 400) : null;
  const viewport =
    typeof window !== "undefined" ? `${window.innerWidth}x${window.innerHeight}` : null;
  const email = args.email ? args.email.trim().toLowerCase().slice(0, 254) : null;

  try {
    void supabase
      .from("dealer_signup_attempts")
      .insert({
        email,
        account_type: "dealer",
        step: args.step,
        error_field: args.errorField ?? null,
        error_message: args.errorMessage ? args.errorMessage.slice(0, 500) : null,
        user_agent: userAgent,
        viewport,
        country: "RO",
        metadata: { source: "dealeri_wizard", ...(args.metadata ?? {}) },
      })
      .then(({ error }) => {
        if (error) console.warn("[dealer-signup-step] insert failed", error.message);
      });
  } catch {
    /* ignore */
  }

  if (BLOCKING_STEPS.includes(args.step)) {
    try {
      void alertDealerSignupBlock({
        data: {
          email,
          step: args.step,
          errorField: args.errorField ?? null,
          errorMessage: args.errorMessage ?? null,
          userAgent,
          viewport,
          metadata: args.metadata ?? null,
        },
      }).catch(() => {});
    } catch {
      /* ignore */
    }
  }
}
